module.exports = __webpack_public_path__ + "static/media/socialOverlay10.9f0acf9e.png";